module.exports = __webpack_public_path__ + "static/media/ZECHEK.ab463978.svg";